// extracted by mini-css-extract-plugin
export var chevronIcon = "_bo-2";
export var teamName = "_bo-1";
export var teamSwitcherButton = "_bo-0";